import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectFeatureFlags } from './ContextSelector';

export const defaults = {
    brightEdgeData: {},
    key: null,
    nodes: [],
    pageGroups: [],
};

export const selectEnableBrightEdge = createSelector([selectFeatureFlags], (featureFlags) =>
    get(featureFlags, 'enableBrightEdge', false)
);

export const selectBrightEdgeData = (state) => state.brightEdgeData || defaults.brightEdgeData;

export const selectKey = createSelector([selectBrightEdgeData], (data) =>
    get(data, 'key', defaults.key)
);

export const selectPageNodes = createSelector([selectBrightEdgeData], (data) =>
    get(data, 'nodes', defaults.nodes)
);

export const selectBodyNode = createSelector([selectPageNodes], (nodes) => {
    const bodyNode = nodes?.find((node) => node.feature_group === 'body_1');
    return get(bodyNode, 'content', '');
});

export const selectHeadNode = createSelector([selectPageNodes], (nodes) => {
    const headNode = nodes?.find((node) => node?.feature_group === '_head_open');
    return get(headNode, 'content', '');
});

export const selectDefaultPageGroups = createSelector([selectBrightEdgeData], (data) =>
    get(data, 'config.page_groups', defaults.pageGroups)
);

export const selectDefaultPageGroupNodes = createSelector([selectBrightEdgeData], (data) =>
    get(data, 'page_group_nodes', null)
);
